import moment from "moment";
import React from "react";
import Select from "react-select";
import { Icon } from "@virtuslab/tetrisly-icons";
import {
  FormControlLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/auth/authSlice";

const DateFilter = ({
  selectedDate,
  setSelectedDate,
  dates,
  options,
  setSelectedOption,
  view,
  setView,
  startDate,
  endDate,
  possibleInsertionsPerGroup,
}) => {
  const user = useSelector(selectUser);
  const [anchorElDate, setAnchorElDate] = React.useState(null);
  const handleOpenDateMenu = (event) => {
    setAnchorElDate(event.currentTarget);
  };
  const handleCloseDateMenu = (date) => {
    setSelectedDate(date);
    setAnchorElDate(null);
  };
  return (
    <div className="flex justify-between items-center">
      {view === "providers" ? (
        <div className="flex gap-8 items-center">
          <button
            disabled={selectedDate === dates[0]?.date}
            onClick={() => {
              const index = dates.findIndex(
                (date) => date.date === selectedDate
              );
              setSelectedDate(dates[index - 1]?.date);
            }}
            className="flex relative justify-center items-center w-10 rounded-md group aspect-square bg-primarylightgrey disabled:opacity-40"
          >
            <Icon name="20-arrowhead-left" />
            <p className="absolute px-2 py-1 text-xs transition-all duration-150 rounded-md opacity-[0%] -z-40 whitespace-nowrap -bottom-14 group-hover:z-50 group-hover:opacity-100 bg-primarylightgrey border-[0.5px] border-primarygrayborder shadow-sm">
              Previous Day
            </p>
          </button>
          <Tooltip title="Select Date">
            <button onClick={handleOpenDateMenu} className="underline">
              <p className="m-0 text-xl font-bold">
                {moment(selectedDate).format("dddd MMMM Do, YYYY")}
              </p>
            </button>
          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElDate}
            open={Boolean(anchorElDate)}
            onClose={handleCloseDateMenu}
            slotProps={{
              paper: {
                style: {
                  maxHeight: 300,
                },
              },
            }}
          >
            {dates.map(({ date, possibleInsertionsCount }) => (
              <MenuItem key={date} onClick={() => handleCloseDateMenu(date)}>
                <Typography className="mx-2" textAlign="center">
                  {moment(date).format("dddd MMMM Do, YYYY")} -{" "}
                  {possibleInsertionsCount}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
          <button
            onClick={() => {
              const index = dates.findIndex(
                (date) => date.date === selectedDate
              );
              setSelectedDate(dates[index + 1]?.date);
            }}
            disabled={selectedDate === dates[dates.length - 1]?.date}
            className="flex relative justify-center items-center w-10 rounded-md group aspect-square bg-primarylightgrey disabled:opacity-40"
          >
            <Icon name="20-arrowhead-right" color="#3062D4" />
            <p className="absolute px-2 py-1 text-xs transition-all duration-150 rounded-md opacity-[0%] -z-40 whitespace-nowrap -bottom-14 group-hover:z-50 group-hover:opacity-100 bg-primarylightgrey border-[0.5px] border-primarygrayborder shadow-sm">
              Next Day
            </p>
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-0 items-start">
          <p className="self-start m-0 text-lg font-bold">
            Top Provider Options ({moment(startDate).format("MMMM DD")} -{" "}
            {moment(endDate).format("MMMM DD")})
          </p>
          <div className="flex gap-2 items-center">
            <p className="text-sm font-normal">
              <span className="font-bold">{`< 50 miles: `}</span>
              {possibleInsertionsPerGroup?.under50 || "0"}{" | "}
            </p>
            <p className="text-sm font-normal">
              <span className="font-bold">{`< 75 miles: `}</span>
              {possibleInsertionsPerGroup?.under75 || "0"}{" | "}
            </p>
            <p className="text-sm font-normal">
              <span className="font-bold">{`< 100 miles: `}</span>
              {possibleInsertionsPerGroup?.under100 || "0"}{" | "}
            </p>
            <p className="text-sm font-normal">
              <span className="font-bold">{`≥ 100 miles: `}</span>
              {possibleInsertionsPerGroup?.above100 || "0"}
            </p>
          </div>
        </div>
      )}
      <div className="flex space-x-4">
        <div className="flex gap-1 items-center rounded-md border border-primarygrayborder">
          <span className="text-sm font-bold w-[80px] px-2">Sort By:</span>
          <div>
            <Select
              options={options}
              onChange={(selectedOption) => {
                if (user?.permissions?.includes('dispatch.edit_sort_by')) {
                  setSelectedOption(selectedOption);
                }
              }}
              defaultValue={options[0]}
              isDisabled={!user?.permissions?.includes('dispatch.edit_sort_by')}
              styles={{
                control: (base) => ({
                  ...base,
                  border: "none",
                  boxShadow: "none",
                  backgroundColor: "transparent",
                }),
                menu: (base) => ({ ...base, zIndex: 9999, width: "200px" }),
              }}
            />
          </div>
        </div>
        <div className="flex overflow-hidden rounded-md border">
          <button
            onClick={() => setView("list")}
            className={`px-4 py-2 text-sm font-medium ${
              view === "list"
                ? "bg-primaryblue text-white"
                : "bg-white text-gray-700"
            }`}
          >
            List View
          </button>
          <button
            onClick={() => setView("providers")}
            className={`px-4 py-2 text-sm font-medium ${
              view === "providers"
                ? "bg-primaryblue text-white"
                : "bg-white text-gray-700"
            }`}
          >
            Providers
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
